// extracted by mini-css-extract-plugin
module.exports = {"banner":"_32bbee5fda--banner--YR8Vo","left-border":"_32bbee5fda--left-border--MVpKU","right-border":"_32bbee5fda--right-border--ny4Xi"};